import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { NewsItem } from "../../business/interface/api/api-news.interface";
@Component({
  selector: "app-news-modal",
  templateUrl: "./news-modal.component.html",
  styleUrls: ["./news-modal.component.css"],
})
export class NewsModalComponent implements OnInit {
  item: NewsItem;
  safeDetails: SafeHtml = "";

  constructor(
    private dialogRef: MatDialogRef<NewsModalComponent>,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: { item: NewsItem },
  ) {}

  ngOnInit() {
    this.item = this.data?.item;
    const html = this.item?.detailsTH?.[0]?.editor ?? "";
    this.safeDetails = this.sanitizer.bypassSecurityTrustHtml(html);
  }

  coverUrl(size: "small" | "medium" = "medium"): string {
    return (
      this.item?.coverImage?.formats?.[size]?.url ||
      this.item?.coverImage?.url ||
      ""
    );
  }

  onClose() {
    this.dialogRef.close();
  }
}
